import { ReactEditor } from 'slate-react';
import { CustomEditor } from 'components/text-editor/hooks/use-custom-editor/index';
import updateAnnotationHOF from 'components/text-editor/hooks/use-custom-editor/actions/update-annotation';
export default function unMarkNodeAsSelected(editor: CustomEditor) {
  const updateAnnotation = updateAnnotationHOF(editor);

  return function () {
    // @ts-ignore
    const selectedNodes = editor.filterNodes((node) => node.isSelected);

    selectedNodes.forEach((selectedNode) => {
      let at: any = undefined;

      try {
        at = ReactEditor.findPath(editor, selectedNode);
      } catch (error) {
        console.log('------------- FIND PATH ERROR ----------------');
      }

      updateAnnotation(
        {
          isSelected: false,
          annotationId: selectedNode?.annotationId,
        },
        { at },
      );
    });
  };
}
